import axios from "axios";
import { ACR, BASE_URL, } from "../../constant/urls";
import {handleMucjCableData} from '../Exchange-View/Exchangecabledetails.util';

// axios call to handle mucj cable update
export const handleMucjCableUpdate = async (setMucjLoader,updateFields, url2,setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg, params, setOpenModal,setMUCJTableData,viewjobid,setLoading,setSelectedMUCJRows) => {
    try {
      setMucjLoader(true);
      const payload = {
        job_id: updateFields.job_id,
        logged_user: updateFields.ein,
        cr_ref: updateFields.cr_ref,
        cable: updateFields.cable_id,
        cable_weight: updateFields.cable_weight,
        cable_length: updateFields.cable_length,
        cable_gauge: updateFields.cable_gauge,
        
      };
    
        const response = await axios.post(`${BASE_URL}/${ACR}/update_mucj_cable`, payload, 
             { params:params},
        );
        if (response.data.Status_code === 200 && response.data.status.toLowerCase() === "success") {
            setSuccessSnackMsg(response.data.MESSAGE); 
            setSuccessAlertOpen(true);
            setOpenModal(false); 
            handleMucjCableData(params,url2,setMUCJTableData,viewjobid,setSelectedMUCJRows,setLoading,setSnackMsg,setAlertOpen); // Calling the GET API function here
            setSelectedMUCJRows([]);
            setMucjLoader(false);
          
        } 
        else if(response.data.Status_code === 200 && response.data.status.toLowerCase() === "fail") {
            setSnackMsg(response.data.MESSAGE); 
            setAlertOpen(true);
            setOpenModal(false);
            setMucjLoader(false);

        }
        else if(response.data.Status_code === 500 && response.data.status.toLowerCase() === "fail") {
            console.log(response.data.MESSAGE);
            setSnackMsg(response.data.MESSAGE);   
            setAlertOpen(true);
            setMucjLoader(false);
        }
    } catch (error) {
        console.error(error);
        setSnackMsg('Something went wrong! Please try again.');
        setAlertOpen(true);
        setMucjLoader(false);
    }
  };